import { EntityService } from '@/services/EntityService';
import { ErrorWrapper, ResponseWrapper } from '@/services/util';

export class RequestVacationsService extends EntityService {
  static get entity() {
    return 'ereporter/request-vacations';
  }

  static async getStatuses(params = {}) {
    try {
      const response = await this.request().get(
        `${this.entity}/filter/statuses`,
        {
          params
        }
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
}
